import React, { Component } from 'react';
import { connect } from 'shalala';
import { Link } from 'react-router-dom';
import { Guardian } from '@xaamin/guardian';
import { Button, Row, Col } from 'react-bootstrap';

import { useStore } from '../../store';
import ClientesList from './list/ClientesList';
import ClientesSearch from './list/components/ClientesSearch';
import ClientesTypeFilter from './list/components/ClientesTypeFilter';
import ClientesItemActions from './list/components/ClientesItemActions';

class Clientes extends Component {
  state = {
    selectedRowKeys: [],
    selectedRows: [],
  };

  componentDidMount() {
    window.setAppTitle('Clientes');
  }

  handleOnRowSelectionChange = ({ selectedRowKeys, selectedRows }) => {
    this.setState({
      selectedRowKeys,
      selectedRows,
    });
  };

  handleOnRowClick = (data) => {
    this.props.history.replace({
      pathname: `/admin/clientes/${data.id}/info`,
      state: {
        data: { ...data },
      },
    });
  };

  highlight = (item) => {
    this.handleOnRowSelectionChange({
      selectedRowKeys: [],
      selectedRows: [],
    });

    this.props.listActions.highlight(item);
  };

  render() {
    const { selectedRowKeys, selectedRows } = this.state;

    return (
      <>
        <Row>
          {selectedRowKeys.length === 0 && (
            <Col
              sm="12"
              md="9"
            >
              <ClientesSearch />
            </Col>
          )}

          {selectedRowKeys.length > 0 && (
            <Col
              sm="12"
              md="9"
            >
              <div className="mb-3">
                <ClientesItemActions
                  selectedRowKeys={selectedRowKeys}
                  selectedRows={selectedRows}
                  highlight={this.highlight}
                />
              </div>
            </Col>
          )}

          <Col
            sm="12"
            md="3"
            className="text-right"
          >
            {Guardian.allows('cliente.crear') && (
              <Link
                to="/admin/clientes/registrar"
                className="mr-3"
              >
                <Button>Nuevo cliente</Button>
              </Link>
            )}
          </Col>
        </Row>

        <ClientesTypeFilter />

        {Guardian.allows('cliente.listar') && (
          <ClientesList
            selectedRowKeys={selectedRowKeys}
            onRowClick={this.handleOnRowClick}
            onRowSelectionChange={this.handleOnRowSelectionChange}
          />
        )}
      </>
    );
  }
}

const mapState = (store) => {
  return { list: store.admin.clientes.list };
};

const mapActions = (actions) => {
  return { listActions: actions.admin.clientes.list };
};

export default connect(useStore, mapState, mapActions)(Clientes);
